export const REDUCER_NAME = 'NETWORK'

